<template>
    <client-page>
        <template v-slot:subHead>
            <sub-visual sh="Company" tabActive="History" bg="/images/sub/visual/sv-company.jpg" />
        </template>

        <sub-section class="page-section--first page-section--last">
            <div class="tit-wrap text-center">
                <h3 class="tit tit--lg">History</h3>
            </div>

            <div class="history-items">
                <v-row class="history-item">
                    <v-col cols="12" md="6">
                        <h4 class="history-item__year">2024</h4>
                    </v-col>
                    <v-col cols="12" md="6" data-aos="fade-right">
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <!-- <div class="w-50px"><strong class="font-size-14 font-size-md-16"></strong></div> -->
                                <div><strong class="font-size-14 font-size-md-16">Undetermined</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Planned office relocation</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row class="history-item">
                    <v-col cols="12" md="6">
                        <h4 class="history-item__year">2023</h4>
                    </v-col>
                    <v-col cols="12" md="6" data-aos="fade-right">
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">11.01</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Establishing Yoojin as a subsidiary</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">07.15</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>
                                        Purchased corporation building <br />
                                        [Location : 8, Neungdong-ro 50-gil, Gwangjin-gu (Woosung Bldg)]
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">02.24</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Establishing Youth Trading as a subsidiary</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">01.30</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>GLOBAL RECYCLED STANDARD(GRS)</v-col>
                                </v-row>
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>ORGANIC COTTON STANDARD(OCS)</v-col>
                                </v-row>
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>BETTER COTTON INITIATIVE(BCI)</v-col>
                                </v-row>
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Eco-friendly certification registration</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row class="history-item">
                    <v-col cols="12" md="6">
                        <h4 class="history-item__year">2022</h4>
                    </v-col>
                    <v-col cols="12" md="6" data-aos="fade-right">
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">06.01</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Converted to company-affiliated research institute</v-col>
                                </v-row>
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Opened corporation website</v-col>
                                </v-row>
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Founded new corporation (Location : Gwangjin-gu, Seoul)</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">01.01</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Managed corporation. Established ERP system for production</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row class="history-item">
                    <v-col cols="12" md="6">
                        <h4 class="history-item__year">2021</h4>
                    </v-col>
                    <v-col cols="12" md="6" data-aos="fade-left">
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">12.31</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Accomplished 200% sales</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">10.28</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Designated as IBK BEST PARTNER - Certified as business with outstanding export</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">10.14</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Signed MOU with Consortium for HRD Ability Magnified Program on manpower training project</v-col>
                                </v-row>
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Seoul Human Resources Development Institute, Korea Chamber of Commerce and Industry</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">06.01</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Established a division for affiliates</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row class="history-item">
                    <v-col cols="12" md="6">
                        <h4 class="history-item__year">2020</h4>
                    </v-col>
                    <v-col cols="12" md="6" data-aos="fade-right">
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">09.01</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Purchased corporation building [Location : 344, Neungdong-ro, Gwangjin-gu (Dongjin Bldg)]</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row class="history-item">
                    <v-col cols="12" md="6">
                        <h4 class="history-item__year">2018</h4>
                    </v-col>
                    <v-col cols="12" md="6" data-aos="fade-left">
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">12.05</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Joined Korea International Trade Association</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">11.22</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Changed overseas corporation name <br class="d-none d-md-block" />SHAOTEXTILE CO., LTD.</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row class="history-item">
                    <v-col cols="12" md="6">
                        <h4 class="history-item__year">2015</h4>
                    </v-col>
                    <v-col cols="12" md="6" data-aos="fade-right">
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">03.10</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Founded overseas corporation <br class="d-none d-md-block" />SHAOTEX CO., LIMITED</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row class="history-item">
                    <v-col cols="12" md="6">
                        <h4 class="history-item__year">2014</h4>
                    </v-col>
                    <v-col cols="12" md="6" data-aos="fade-left">
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">07.01</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Changed corporate name <br class="d-none d-md-block" />Unitex Corp. → Meitextile Co.,Ltd.</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row class="history-item">
                    <v-col cols="12" md="6">
                        <h4 class="history-item__year">2010</h4>
                    </v-col>
                    <v-col cols="12" md="6" data-aos="fade-right">
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">00.00</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Founded Unitex Corp.</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row class="history-item">
                    <v-col cols="12" md="6">
                        <h4 class="history-item__year">2000</h4>
                    </v-col>
                    <v-col cols="12" md="6" data-aos="fade-left">
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">00.00</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Founded Uniworth Corp.</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </div>
        </sub-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import SubSection from "@/components/client/sub/sub-section.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubSection,
    },
};
</script>

<style lang="scss" scoped>
.history-item {
    margin: -8px;
}
.history-item + .history-item {
    margin-top: 24px;
}
.history-item > [class*="col"] {
    padding: 8px;
}
.history-item__year {
    font-size: 4rem;
    line-height: 1;
    color: var(--v-primary-base);
}
.row--small.page-text + .row--small.page-text {
    margin-top: 0;
}
.history-item > [class*="col"] > .row--small + .row--small {
    margin-top: 12px;
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .history-item {
        position: relative;
        margin: -40px;
    }
    .history-item::before {
        content: "";
        position: absolute;
        top: 56px;
        left: 50%;
        -webkit-transform: translate(-50%, 0);
        -ms-transform: translate(-50%, 0);
        transform: translate(-50%, 0);
        display: block;
        width: 1px;
        height: 100%;
        background-color: var(--border-color);
    }
    .history-item + .history-item {
        margin-top: 0;
    }
    .history-item:last-child:before {
        display: none;
    }
    .history-item > [class*="col"] {
        padding: 40px;
    }
    .history-item__year {
        position: relative;
        font-size: 6rem;
        margin-top: -2rem;
        text-align: right;
        color: var(--v-primary-lighten5);
    }
    .history-item__year::before {
        content: "";
        position: absolute;
        top: 50%;
        right: -55px;
        -webkit-transform: translate(0, -50%);
        -ms-transform: translate(0, -50%);
        transform: translate(0, -50%);
        display: block;
        width: 30px;
        height: 30px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        background-image: url(/images/sub/company/history-symbol.png);
    }
    .history-item:nth-child(even) > [class*="col"]:nth-child(1),
    .history-item:nth-child(even) > [class*="col"]:nth-child(2) > .row > [class*="col"]:nth-child(1),
    .history-item:nth-child(even) .row.page-text > [class*="col"]:nth-child(1) {
        order: 2;
    }
    .history-item:nth-child(even) .history-item__year {
        text-align: left;
    }
    .history-item:nth-child(even) .history-item__year::before {
        right: auto;
        left: -55px;
    }
    .history-item:nth-child(even) > [class*="col"]:nth-child(2) {
        text-align: right;
    }
}
@media (min-width: 1024px) {
    .history-item {
        margin: -70px;
    }
    .history-item + .history-item {
        margin-top: 70px;
    }
    .history-item::before {
        top: 76px;
    }
    .history-item > [class*="col"] {
        padding: 70px;
    }
    .history-item > [class*="col"] > .row--small + .row--small {
        margin-top: 20px;
    }
    .history-item__year {
        font-size: 12rem;
        margin-top: -5rem;
        margin-bottom: 0;
    }
    .history-item__year::before {
        right: -85px;
    }
    .row--small.page-text + .row--small.page-text {
        margin-top: 6px;
    }
    .history-item:nth-child(even) .history-item__year::before {
        right: auto;
        left: -85px;
    }
}
@media (min-width: 1200px) {
}
</style>
